import "../../assets/css/icons.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark, faCircleCheck } from "@fortawesome/free-regular-svg-icons";

export const SuccessIcon = () => (
  <FontAwesomeIcon icon={faCircleCheck} className="form-control__icon" />
);
export const ErrorIcon = () => (
  <FontAwesomeIcon icon={faCircleXmark} className="form-control__icon" />
);
